<template>
  <div class="cropper-content">
    <div class="cropper-box">
      <div class="cropper">
        <vue-cropper
          ref="cropper"
          :img="option.img"
          :output-size="option.outputSize"
          :output-type="option.outputType"
          :info="option.info"
          :can-scale="option.canScale"
          :auto-crop="option.autoCrop"
          :auto-crop-width="option.autoCropWidth"
          :auto-crop-height="option.autoCropHeight"
          :fixed="option.fixed"
          :fixed-number="option.fixedNumber"
          :full="option.full"
          :fixed-box="option.fixedBox"
          :can-move="option.canMove"
          :can-move-box="option.canMoveBox"
          :original="option.original"
          :center-box="option.centerBox"
          :height="option.height"
          :info-true="option.infoTrue"
          :max-img-size="option.maxImgSize"
          :enlarge="option.enlarge"
          :mode="option.mode"
          @realTime="realTime"
          @imgLoad="imgLoad"
        />
      </div>
      <!--底部操作工具按钮-->
      <div class="footer-btn">
        <div class="scope-btn">
          <label class="btn" for="uploads">上传头像</label>
          <input
            id="uploads"
            type="file"
            style="position: absolute; clip: rect(0 0 0 0)"
            accept="image/png, image/jpeg, image/gif, image/jpg"
            @change="selectImg($event)"
          >
        </div>
        <div class="scope-info">
          <p class="font-color-7B84A1 font-size-12">
            请上传分辨率大于300x300的jpg或png图片，图片大小不要超过20M
          </p>
        </div>
      </div>
    </div>
    <!--预览效果图-->
    <!-- <div class="show-preview">
      <div :style="previews.div" class="preview">
        <img :src="previews.url" :style="previews.img">
      </div>
    </div> -->
  </div>
</template>

<script>
import { VueCropper } from 'vue-cropper'
import axios from 'axios'
import auth from '../../../../../models/auth.js'
import config from '../../../../../utils/config.js'
import { Base64 } from 'js-base64'
export default {
  name: 'CropperImage',
  components: {
    VueCropper
  },
  data() {
    return {
      name: this.Name,
      uploadInstance: null,
      previews: {},
      option: {
        img: '', // 裁剪图片的地址
        outputSize: 1, // 裁剪生成图片的质量(可选0.1 - 1)
        outputType: 'jpeg', // 裁剪生成图片的格式（jpeg || png || webp）
        info: true, // 图片大小信息
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 300, // 默认生成截图框宽度
        autoCropHeight: 300, // 默认生成截图框高度
        fixed: false, // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1], // 截图框的宽高比例
        full: true, // false按原比例裁切图片，不失真
        fixedBox: false, // 固定截图框大小，不允许改变
        canMove: true, // 上传图片是否可以移动
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        height: true, // 是否按照设备的dpr 输出等比例图片
        infoTrue: true, // true为展示真实输出图片宽高，false展示看到的截图框宽高
        maxImgSize: 3000, // 限制图片最大宽度和高度
        enlarge: 1, // 图片根据截图框输出比例倍数
        mode: '300px 300px' // 图片默认渲染方式
      }
    }
  },
  mounted() {
    let baseStr = this.$store.state.user.application.clientId+':'+store.state.user.application.clientSecret;
    this.uploadInstance = axios.create({
      baseURL: config.profile.host,
      headers: { 'Content-Type': 'multipart/form-data', 'cloud-auth': 'bearer ' + auth.gettoken(), 'Authorization': 'Basic ' + Base64.encode(baseStr) }//'cloud_app:cloud_app_secret'
    })
  },
  methods: {
    // 初始化函数
    imgLoad(msg) {
      this.finish()
    },
    // 图片缩放
    changeScale(num) {
      num = num || 1
      this.$refs.cropper.changeScale(num)
    },
    // 向左旋转
    rotateLeft() {
      this.$refs.cropper.rotateLeft()
    },
    // 向右旋转
    rotateRight() {
      this.$refs.cropper.rotateRight()
    },
    // 实时预览函数
    realTime(data) {
      this.previews = data
    },
    // 选择图片
    selectImg(e) {
      const file = e.target.files[0]
      const size = e.target.files[0].size

      if (size / 1024 / 1024 > 20) {
        this.$message({
          message: '图片大小不要超过20M',
          type: 'error'
        })
        return false
      }
      if (!/\.(jpg|png|JPG|PNG)$/.test(e.target.value)) {
        document.getElementById('uploads').value = null
        this.$message({
          message: '请上传分辨率大于300x300的jpg或png图片',
          type: 'error'
        })
        return false
      }
      // 转化为blob
      const reader = new FileReader()
      const that = this
      reader.onload = (r) => {
        let data
        if (typeof r.target.result === 'object') {
          data = window.URL.createObjectURL(new Blob([r.target.result]))
        } else {
          data = r.target.result
        }
        var imageObj = new Image()
        imageObj.src = data
        imageObj.onload = function() {
          if (imageObj.width < 300 || imageObj.height < 300) {
            that.$message({
              message: '请上传分辨率大于300x300的jpg或png图片',
              type: 'error'
            })
          } else {
            that.option.img = data
          }
        }
      }
      // 转化为base64
      reader.readAsDataURL(file)
    },
    finish() {
    },
    // 上传图片
    uploadImg(type) {
      const _this = this
      // 获取截图的blob数据
      if (!this.option.img || this.option.img === '') {
        this.$message({
          message: '请上传分辨率大于300x300的jpg或png图片',
          type: 'error'
        })
        return
      }
      this.$refs.cropper.getCropBlob(async(data) => {
        console.log(data)
        const formData = new FormData()
        formData.append('file', data, 'dx.jpg')
        formData.append('tenantId', this.$store.getters.tenantId)
        this.uploadInstance.post('/adks-app/oss/upload', formData).then(r => {
          _this.$emit('success', r.data)
        })
      })
    }
  }
}
</script>
<style src="@/styles/pc.css" scoped>
</style>
<style scoped lang="scss">
.cropper-content {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  .cropper-box {
    flex: 1;
    width: 100%;
    .cropper {
      width: 300px;
      height: 300px;
    }
  }

  .show-preview {
    flex: 1;
    -webkit-flex: 1;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    .preview {
      overflow: hidden;
      border: 1px solid #67c23a;
      background: #cccccc;
    }
  }
}
.footer-btn {
  margin-top: 20px;
  .scope-btn {
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    padding-right: 10px;
  }
  .scope-info {
    height: 44px;
    line-height: 44px;
  }
  .upload-btn {
    flex: 1;
    -webkit-flex: 1;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
  }
  .btn {
    outline: none;
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    font-size: 14px;
    color: #fff;
    background-color: #264480;
    border-color: #409eff;
    width: 82px;
    height: 30px;
    border-radius: 5px;
    text-align: center;
    line-height: 30px;
  }
}
</style>
